import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActions as cpdCategoryApiActions } from '../../areas-of-advice/actions';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_CPD_CATEGORY: (cpdCategoryId, data, icon, noRedirect) => ({ cpdCategoryId, data, icon, noRedirect }),
    API: {
      UPDATE_CPD_CATEGORY: apiResourceActionCreator('cpdCategory')
    }
  }
})

export const apiAction = (authToken, cpdCategoryId, formData) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}/update-cpd-category/${cpdCategoryId}`, authToken, formData, actions.admin.api.updateCpdCategory);

function* updateCpdCategory(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.cpdCategoryId, {
    data: action.payload.data,
    file: action.payload.icon
  }));

  const result = yield apiActionResult(actions.admin.api.updateCpdCategory);

  if (result.success) {
    if (action.payload.noRedirect) {
      yield put(cpdCategoryApiActions.cpdCategorys.get(authToken))
    } else {
      yield put(push({ pathname: routes.adminPortal.cpdCategory }));
    }
  }
}

const configuration = {
  name: 'updateCpdCategory',
  action: actions,
  sagas: updateCpdCategory,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateCpdCategory.js